import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import { Typography } from "@material-ui/core";
import { useSelector,useDispatch } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { useTranslation } from "react-i18next";

import { linksApiLoading } from "../../../model/action";
const useStyles = makeStyles((theme) => ({
  errroIcon: {
    width: "10em",
    height: "auto",
    margin: "2em auto",
    display: "block",
    color: theme.palette.eLight.base,
  },
  errorText: {
    textAlign: "center",
  },
  viewAll: {
    textAlign: "center",
    color: theme.palette.ePrimary.base,
    margin: "2em auto",
  },
  faqGrid: {
    marginTop: "2%",
  },
  faqTitle: {
    fontSize: "0.8em",
    fontWeight: "500",
  },
  mobileHeading: {
    color: theme.palette.ePrimary.base,
    textAlign: "center",
    paddingTop:'0.4rem'
  },
  p2: {
    padding: "2%",
  },
  linkStyle: {
    margin: "1em auto",
    fontSize: "0.875rem",
    color: theme.palette.ePrimary.base,
  },
  headingStyling: {
    fontSize: "1rem !important",
  },
  marginTopLinks:{
    marginTop:"2%"
  }
}));
function EUsefulLinks({ getLinksData, keyWord, searchLinksData }) {
  const dispatch= useDispatch()
  const classes = useStyles();
  const {t:labels, ready: labelReady} = useTranslation("label-E_AUTH_LOGIN");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [linksData, setLinksData] = useState([]);
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const { i18n } = useTranslation("content-LINKS_AUTH");
  let i18nObject = i18n.store.getResourceBundle("en","content-LINKS_AUTH");
  const linksArray = [];
  useEffect(() => {
    if (i18nObject && Object.values(i18nObject).length) {
      Object.keys(i18nObject).forEach(key => {
        if (!i18nObject[key]?.answer.includes("baseUrl")) {
          linksArray.push(i18nObject[key]);
        }
      });
      setLinksData(linksArray);
    }
  }, [i18nObject]);
  useEffect(() => {
    if (keyWord === undefined) {
        dispatch(linksApiLoading(true))
        setIsError(false);
        setLinks(linksData);
        dispatch(linksApiLoading(false))
    } else {
      if (searchLinksData) {
        setLinks(searchLinksData);
      }
    }
  }, [linksData]);
  return (
    <>
      {loading && (
        <>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
          <Skeleton variant="text"></Skeleton>
        </>
      )}
      {isError && (
        <>
          <ReportProblemOutlinedIcon className={classes.errroIcon} />
          <Typography className={classes.errorText}>
            {labelReady ? labels("E_ERROR_MESSAGE") : <Skeleton />}
          </Typography>
        </>
      )}

      {(links.length && !isError) || !loading ? (
        <>
          <div className={classes.p2}>
            {isTabletOrMobile && (
              <Typography
                variant="h3"
                class={classes.mobileHeading}
                align="center"
              >
                {labelReady ? labels("E_LINKS_MOBILE_HEADING") : <Skeleton />}
              </Typography>)}
              <Typography variant="caption" className={classes.headingStyling}>
                {labelReady ? labels("E_LINKS_DESKTOP_HEADING") : <Skeleton />}
              </Typography>
            <br />
            <Typography className={classes.marginTopLinks}>
              {links.map((link, index) => {
                return (
                  <>
                    <a
                      className={classes.linkStyle}
                      key={index}
                      target="_blank"
                      href={link.answer ? link.answer :link?._source?.ContentValue}
                    >
                      {link.question ? link.question :link?._source?.ContentTitle}
                    </a>
                    <br />
                  </>
                );
              })}
            </Typography>
          </div>
        </>
      ) : !loading && ( <>
        <ReportProblemOutlinedIcon className={classes.errroIcon} />
        <Typography className={classes.errorText}>
          {labelReady ? labels("E_NO_RECORDS_FOUND_MESSAGE") : <Skeleton />}
        </Typography>
      </>)}
    </>
  );
}

export default EUsefulLinks;
